/* * 图层树 * @module components/layertree/treeContrast * @desc 用于对比图层树 * @author zhaoting *
@date 2020年8月13日 */
<template>
  <div>
    <div id="layertree-all">
      <div id="layertree-pop" class="tmp">
        <div class="selectCode">
          <Select v-model="selectValue" @on-select="changeSlect" class="leftSelect">
            <Option
              :value="item.id"
              v-for="item in selectList"
              :key="item.id"
              :label="item.title"
              >{{ item.title }}</Option
            >
          </Select>
        </div>
        <div class="treeContent">
          <Tree
            :render="renderContent"
            :data="comparlayers"
            show-checkbox
            ref="componenttree"
            :empty-text="loadtreeText"
            @on-select-change="handleSetZoom"
            @on-check-change="sel"
          ></Tree>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import treeContrast from './treeContrast';
export default treeContrast;
</script>
<style lang="less" scoped>
#layertree-all {
  font-size: 12px;
  position: absolute;
  width: 90%;
  overflow: auto;
  overflow-x: hidden;
  z-index: 99;
  margin-top: -10px;
  border: 1px solid #e8eaecd6;
}

#layertree-title {
  background-color: #e2e8f7;
  height: 40px;
  line-height: 40px;
  padding-left: 15px;
  font-weight: bold;
}
.selectCode{
  width: 100%;
  height: 40px;
  margin-top: 10px;
}
.treeContent{
  width: 100%;
  height: 340px;
  overflow: hidden auto;
}
#layertree-pop {
  width: 100%;
  height: 400px;
  padding: 5px 10px;
  border-radius: 2px;
  background-color: #fff;
  z-index: 3;
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
/deep/.ivu-tree-empty{
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/contrastComponent/treeContrast/treeContrast.vue